import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Download, Lock } from 'lucide-react';
export const PricingSection = () => {
  return <section id="compra" className="py-8 sm:py-24 bg-white border-y border-neutral-200 relative overflow-hidden" data-id="element-209">
      <div className="container mx-auto px-4 sm:px-4 max-w-4xl relative z-10" data-id="element-210">
        <div className="text-center mb-3 sm:mb-12" data-id="element-211">
          <h2 className="text-xl sm:text-4xl font-bold text-neutral-900 mb-0.5 sm:mb-4" data-id="element-212">
            Todo lo que recibís hoy:
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-cream rounded-xl sm:rounded-2xl border-2 border-brand-500 shadow-xl overflow-hidden" data-id="element-213">
          <div className="p-5 sm:p-12" data-id="element-214">
            <ul className="space-y-1.5 sm:space-y-4 mb-3 sm:mb-8 text-[15px] sm:text-xl font-medium" data-id="element-215">
              <li className="flex justify-between items-center border-b border-neutral-200 pb-2 sm:pb-4" data-id="element-216">
                <span className="flex items-center gap-2 sm:gap-3 text-neutral-900" data-id="element-217">
                  <span className="text-lg sm:text-2xl" data-id="element-218">📘</span> Manual CAJA DE
                  COBRO
                </span>
                <span className="text-neutral-500 line-through text-[13px] sm:text-xl" data-id="element-219">
                  $45.000
                </span>
              </li>
              <li className="flex justify-between items-center border-b border-neutral-200 pb-2 sm:pb-4" data-id="element-220">
                <span className="flex items-center gap-2 sm:gap-3 text-neutral-700" data-id="element-221">
                  <span className="text-lg sm:text-2xl" data-id="element-222">🎁</span> Bonus 1: 10
                  Ganchos
                </span>
                <span className="text-neutral-500 line-through text-[13px] sm:text-xl" data-id="element-223">
                  $12.000
                </span>
              </li>
              <li className="flex justify-between items-center border-b border-neutral-200 pb-2 sm:pb-4" data-id="element-224">
                <span className="flex items-center gap-2 sm:gap-3 text-neutral-700" data-id="element-225">
                  <span className="text-lg sm:text-2xl" data-id="element-226">🎁</span> Bonus 2: 25
                  Mensajes
                </span>
                <span className="text-neutral-500 line-through text-[13px] sm:text-xl" data-id="element-227">
                  $18.000
                </span>
              </li>
              <li className="flex justify-between items-center border-b border-neutral-200 pb-2 sm:pb-4" data-id="element-228">
                <span className="flex items-center gap-2 sm:gap-3 text-neutral-700" data-id="element-229">
                  <span className="text-lg sm:text-2xl" data-id="element-230">🎁</span> Bonus 3:
                  Matriz Anti-Crisis
                </span>
                <span className="text-neutral-500 line-through text-[13px] sm:text-xl" data-id="element-231">
                  $15.000
                </span>
              </li>
              <li className="flex justify-between items-center pb-2 sm:pb-4" data-id="element-232">
                <span className="flex items-center gap-2 sm:gap-3 text-neutral-700" data-id="element-233">
                  <span className="text-lg sm:text-2xl" data-id="element-234">🎁</span> Bonus 4: Guion
                  de Cierre
                </span>
                <span className="text-neutral-500 line-through text-[13px] sm:text-xl" data-id="element-235">
                  $20.000
                </span>
              </li>
            </ul>

            <div className="bg-white rounded-lg sm:rounded-xl p-3 sm:p-6 text-center mb-3 sm:mb-8 border border-neutral-200 shadow-sm" data-id="element-236">
              <p className="text-neutral-500 font-bold uppercase tracking-wider mb-0.5 sm:mb-2 text-[12px] sm:text-base" data-id="element-237">
                VALOR TOTAL:
              </p>
              <p className="text-2xl sm:text-3xl font-bold text-neutral-400 line-through decoration-brand-500/50 decoration-2 sm:decoration-4" data-id="element-238">
                $110.000 ARS
              </p>
            </div>

            <div className="text-center" data-id="element-239">
              <p className="text-brand-600 font-bold text-base sm:text-xl mb-1 sm:mb-2 flex items-center justify-center gap-1 sm:gap-2" data-id="element-240">
                🔥 LO CONSEGUÍS HOY POR:
              </p>
              <p className="text-4xl sm:text-7xl font-bold text-neutral-900 mb-2 sm:mb-4" data-id="element-241">
                $19.990 ARS
              </p>

              <a href="https://cobrocaja.cajadecobro.com.ar/checkouts/cn/hWNAVD3JiJjmorrzTyz7HG42/es-ar?_r=AQAB3idz6fnRAWHNE_-1B5yTgkWP3vPO-klPE3gbuSEoAo4" target="_blank" rel="noopener noreferrer" className="group relative flex w-full items-center justify-center gap-2 overflow-hidden rounded-lg sm:rounded-xl bg-brand-600 px-4 py-4 sm:px-8 sm:py-6 font-sans text-lg sm:text-2xl font-bold text-white shadow-lg transition-all hover:bg-brand-700 hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]" data-id="element-242">
                <span className="relative z-10 flex items-center gap-2" data-id="element-243">
                  👇 SÍ, QUIERO MI CAJA DE COBRO AHORA
                </span>
                <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/10 to-transparent transition-transform duration-1000 group-hover:translate-x-full" data-id="element-244" />
              </a>

              <p className="sm:hidden mt-2 text-[11px] text-center text-neutral-400 font-medium" data-id="element-245">
                🔒 Pago seguro · Descarga instantánea · Garantía 7 días ·
                Mercado Pago
              </p>
              <div className="hidden sm:flex mt-6 flex-wrap items-center justify-center gap-4 text-sm font-medium text-neutral-600" data-id="element-246">
                <span className="flex items-center gap-1" data-id="element-247">
                  <Lock className="h-4 w-4 text-brand-600" data-id="element-248" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-249">
                  <Download className="h-4 w-4 text-brand-600" data-id="element-250" /> Descarga
                  instantánea
                </span>
                <span className="flex items-center gap-1" data-id="element-251">
                  <ShieldCheck className="h-4 w-4 text-brand-600" data-id="element-252" /> Garantía 7
                  días
                </span>
              </div>
              <div className="hidden sm:flex mt-4 items-center justify-center gap-2 text-xs text-neutral-500" data-id="element-253">
                🔒 Mercado Pago · Tarjeta · Transferencia
              </div>
            </div>
          </div>
        </motion.div>

        <div className="hidden sm:block mt-16 max-w-3xl mx-auto" data-id="element-254">
          <h3 className="text-2xl font-bold text-neutral-900 mb-6 text-center" data-id="element-255">
            Para ponerlo en perspectiva:
          </h3>
          <div className="space-y-6 text-lg text-neutral-700" data-id="element-256">
            <p className="bg-cream p-6 rounded-xl border border-neutral-200" data-id="element-257">
              Si con este sistema cerrás{' '}
              <strong className="text-brand-600" data-id="element-258">1 solo cliente nuevo</strong>{' '}
              este mes que no hubieras cerrado sin él, la inversión se paga sola
              entre 2 y 10 veces, dependiendo de lo que cobrés.
            </p>
            <p className="bg-cream p-6 rounded-xl border border-neutral-200" data-id="element-259">
              Si reactivás{' '}
              <strong className="text-brand-600" data-id="element-260">1 ex-cliente dormido</strong>{' '}
              con alguno de los 25 mensajes del Bonus 2, ya recuperaste lo
              invertido en las primeras 48 horas.
            </p>
            <p className="text-center text-2xl font-bold text-neutral-900 mt-8" data-id="element-261">
              $19.990 no es el precio de un manual.{' '}
              <span className="text-brand-600" data-id="element-262">
                Es el precio de tu próxima venta.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
};